import { createAction, props } from "@ngrx/store";
import { PageTitlesState } from "../states/pageTitlesState";

export const addToPageTitles = createAction('[PageTitles] Add', props<PageTitlesState>())